import { WalletOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import type { ActivePaymentMethod } from "../../../../../api/paymentMethods";
import { useViewport } from "../../../../../hooks/useViewport";
import { TablesEmptyState } from "../TablesEmptyState";
import { CLOSE_COLUMN_TITLE } from "../payment/closeLayout";
import { CloseMethodRow } from "../payment/CloseMethodRow";

interface DepositMethodListProps {
  methods: ActivePaymentMethod[];
  selectedId: number | null;
  onSelect: (methodId: number) => void;
  /** Метод без правото за него (В брой / С карта) — видим, но неактивен. */
  isMethodDisabled: (methodId: number) => boolean;
  isNarrow: boolean;
}

/**
 * Дясната колона на „Депозити": как е взет депозитът — 1:1 като дясната
 * колона на „Закрий" с бакшиш (`payment/ClosePaymentBody.tsx`): същото
 * заглавие и същите редове (`CloseMethodRow`), без „Смесено" и „По сметка".
 */
export function DepositMethodList({
  methods,
  selectedId,
  onSelect,
  isMethodDisabled,
  isNarrow,
}: DepositMethodListProps) {
  const { t, i18n } = useTranslation();
  const { isTablet } = useViewport();

  return (
    <>
      <div
        className={`${CLOSE_COLUMN_TITLE} ${isTablet && !isNarrow ? "text-[13px]" : "text-[14px]"}`}
      >
        {t("closeTable.selectMethod")}
      </div>
      {methods.length === 0 ? (
        <TablesEmptyState
          icon={<WalletOutlined />}
          title={t("closeTable.noMethodsTitle")}
          description={t("closeTable.noMethodsDescription")}
        />
      ) : (
        <div className={`flex flex-col ${isNarrow ? "gap-1.5" : "gap-2.5"}`}>
          {methods.map((method) => (
            <CloseMethodRow
              key={method.id}
              label={i18n.language === "en" ? method.name_en : method.name_bg}
              isSelected={method.id === selectedId}
              isDisabled={isMethodDisabled(method.id)}
              isNarrow={isNarrow}
              boxed
              onClick={() => onSelect(method.id)}
            />
          ))}
        </div>
      )}
    </>
  );
}
